import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectIncidentsByIds } from '@tokeet-frontend/incident'
import { RejectTask, selectDraftTasks, TaskResponse } from '@tokeet-frontend/tasks'
import { ConfirmDialogService, Destroyable } from '@tokeet-frontend/tv3-platform'
import { OpenEditTaskDialog } from '@tv3/store/overlay/overlay.actions'
import { combineLatest } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'

@Component({
  selector: 'app-automation-draft-tasks',
  templateUrl: './automation-draft-tasks.component.html',
  styleUrls: ['./automation-draft-tasks.component.scss'],
})
export class AutomationDraftTasksComponent extends Destroyable implements OnInit {
  drafts: TaskResponse[] = []
  get count() {
    return this.drafts.length
  }
  constructor(private store: Store<any>, private confirmDialog: ConfirmDialogService) {
    super()
  }

  ngOnInit(): void {
    combineLatest([
      this.store.select(selectDraftTasks).pipe(map((tasks) => tasks.filter((task) => !task.incident_id && task.draft))), // created from automations
      this.store.select(selectDraftTasks).pipe(
        // created from incident, but the incident not from message/review
        map((tasks) => tasks.filter((task) => task.incident_id && task.draft)),
        switchMap((tasks) =>
          this.store.select(selectIncidentsByIds(tasks.map((t) => t.incident_id))).pipe(
            map((incidents) => incidents.filter((i) => !i.message_id && !i.review_id).map((i) => i.pkey)),
            map((incidentIds) => tasks.filter((t) => incidentIds.includes(t.incident_id)))
          )
        )
      ),
    ]).subscribe(([d1, d2]) => {
      this.drafts = [...d1, ...d2]
    })
  }

  onViewTask(task: TaskResponse) {
    this.store.dispatch(OpenEditTaskDialog({ taskId: task.pkey }))
  }

  onRejectTask(task: TaskResponse) {
    this.confirmDialog
      .confirm({
        title: $localize`Reject Task`,
        body: $localize`Are you sure you want to reject this task?`,
      })
      .subscribe(() => {
        this.store.dispatch(RejectTask({ taskId: task.pkey }))
      })
  }

  onApproveTask(task: TaskResponse) {
    this.store.dispatch(OpenEditTaskDialog({ taskId: task.pkey }))
  }
}
